export default "__VITE_ASSET__082b0a24__"